module.exports = __webpack_public_path__ + "img/bespoke70_32.1aba0632.jpg";